/**
 * Keep in sync with `functions/src/shared/offer/normalizeVariationDataSentinels.ts`.
 * Align age/grade UI fields on denormalized variationData with session form defaults.
 */
export function normalizeVariationDataAgeUiSentinels(v: Record<string, unknown> | null | undefined): void {
  if (v == null || typeof v !== "object" || Array.isArray(v)) return;
  const o = v as Record<string, unknown>;
  if (o.showMinAgeGradeAsPrimary == null) o.showMinAgeGradeAsPrimary = false;
  if (o.showMaxAgeGradeAsPrimary == null) o.showMaxAgeGradeAsPrimary = false;
  if (o.minAgeNote == null) o.minAgeNote = "";
  if (o.maxAgeNote == null) o.maxAgeNote = "";
}
